import { Button } from "@/components/ui/button";
import { SubmitButtonConfig } from "../types";

interface SubmitButtonProps {
  config: SubmitButtonConfig;
  disabled?: boolean;
}

export function SubmitButton({ config, disabled }: SubmitButtonProps) {
  return (
    <Button
      type="submit"
      disabled={disabled}
      className="shrink-0"
      aria-label={config.ariaLabel || "Search"}
    >
      {config.icon}
      {config.label || "Search"}
    </Button>
  );
}

